import type { AppState } from './types/index'
import { newNote } from './utils/index'


const note = newNote()
export let globalAppState\AppState = {
	notes: [note],
	currentNote: note
}

# Extend 'element' with a new property for getting an app state value
extend tag element
	get state\AppState
		return globalAppState
	set state\AppState updatedState\AppState
		globalAppState = updatedState
		return globalAppState



